import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PagedData } from '@/Interfaces/_';
import { PutUserRoleParam, UpdateMyPageDataRequest, UserRoleData } from '@/Interfaces/I_userRole';
import { MyPageProfileData, StreamerData, UpdateStreamDataRequest } from '@/Interfaces/I_AccountsManagement';

const userRoleSlice = createSlice({
  name: 'userRoleSlice',
  initialState: {
    value: {
      userRoles: {} as PagedData<UserRoleData>,
      viewingStreamerData: {} as StreamerData,
      myPageProfileData: {} as MyPageProfileData,
    },
    loading: false,
    loadingStreamerData: false,
    loadingMyPageProfileData: false,
    error: '',
  },
  reducers: {
    getUserRole: (state, action) => {
      const assignState = state;
      assignState.loading = true;
    },
    setUserRole: (state, action) => {
      const assignState = state;
      assignState.value = { ...assignState.value, userRoles: action.payload.data };
      assignState.loading = false;
    },
    putUserRole: (state, action) => {},
    spliceUserRole: (state, action) => {
      const assignState = state;
      const tempUserRole = assignState.value.userRoles;
      action.payload.forEach((spliceUser: PutUserRoleParam) => {
        const targetUserIndex = tempUserRole.data.findIndex(
          (user) => user.uuid === spliceUser.uuid,
        );
        console.log("user Index: ", targetUserIndex)
        tempUserRole.data.splice(targetUserIndex, 1);
      });
      assignState.value = { ...assignState.value, userRoles: tempUserRole };
    },
    getStreamerData: (state, _action: PayloadAction<string>) => {
      const assignState = state;
      assignState.loadingStreamerData = true;
    },
    setViewingStreamerData: (state, action: PayloadAction<StreamerData>) => {
      const assignState = state;
      assignState.loadingStreamerData = false;
      assignState.value.viewingStreamerData = action.payload;
    },
    updateStreamerData: (state, _action: PayloadAction<UpdateStreamDataRequest>) => {
      const assignState = state;
      assignState.loadingStreamerData = true;
    },
    getMyPageProfileData: (state, _action: PayloadAction<string>) => {
      const assignState = state;
      assignState.loadingMyPageProfileData = true;
    },
    setMyPageProfileData: (state, action: PayloadAction<MyPageProfileData>) => {
      const assignState = state;
      assignState.loadingMyPageProfileData = false;
      assignState.value.myPageProfileData = action.payload;
    },
    updateMyPageProfileData: (state, _action: PayloadAction<UpdateMyPageDataRequest>) => {
      const assignState = state;
      assignState.loadingMyPageProfileData = true;
    },
  },
});

export const { 
  getUserRole, 
  setUserRole, 
  putUserRole, 
  spliceUserRole, 
  getStreamerData,
  setViewingStreamerData, 
  updateStreamerData,
  getMyPageProfileData,
  setMyPageProfileData,
  updateMyPageProfileData
} = userRoleSlice.actions;

export default userRoleSlice.reducer;
